export enum OrderStatus {
  New = 'new', //Новый
  Paid = 'paid', //Оплачен
  NotPaid = 'not_paid',
  WaitConfirmation = 'wait_confirmation', //Ожидает подтверждения
  WaitTake = 'wait_take', // Ожидает отправки
  Complete = 'complete', //Выполнен
  RefundIssued = 'refund_issued', // Оформлен возврат
  Returned = 'returned', //Возвращен
  PaymentProcess = 'payment_process', // ожидает оплаты
  Canceled = 'canceled', // ожидает оплаты
  All = 'all', //Все
  Error = 'error', //Все
}

export enum OrderStatusString {
  New = 'Новый', //Новый
  Paid = 'Оплачен', //Оплачен
  NotPaid = 'Оплата не прошла',
  PaymentProcess = 'В процессе оплаты', // ожидает оплаты
  WaitConfirmation = 'Ожидает подтверждения', //Ожидает подтверждения
  WaitTake = 'Ожидает отправки', // Ожидает отправки
  Complete = 'Завершен', //Выполнен
  RefundIssued = 'Оформлен возврат', // Оформлен возврат
  Returned = 'Возвращен', //Возвращен
  Canceled = 'Отменен', // ожидает оплаты
  All = 'Все', //Все
  Error = 'Ошибка',
}
